<template>
  <a-modal
    v-model:visible="authExplainModal"
    title="认证提示"
    :footer="null"
    :closable="false"
    width="500px"
  >
    <div class="auth-explain-text">
      您还没进行企业认证，须完成认证，才能正常接入平台能力
    </div>
    <div class="submit-btn">
      <a-button @click="handleResetCancel">
        取消
      </a-button>
      <a-button
        type="primary"
        @click="handleSubmit"
      >
        去认证
      </a-button>
    </div>
  </a-modal>
</template>

<script setup>
import { computed } from 'vue';
import { useModal } from '../store/index';
import { useRouter } from 'vue-router';

const router = useRouter();
const useModalStore = useModal();
const authExplainModal = computed(() => {
  return useModalStore.authModal
})

// 取消
const handleResetCancel = () => {
  useModalStore.changeAuthModal(false);
}
// 去认证
const handleSubmit = () => {
  useModalStore.changeAuthModal(false);
  if(useModalStore.userDetail?.tenantStatus == 0 || useModalStore.userDetail?.tenantStatus == 3) {
    router.push('/enterprise/auth')
  } else if(useModalStore.userDetail?.tenantStatus == 1) {
    router.push('/control/userInfo')
  }
  
}
</script>

<style lang="scss" scoped>
.auth-explain-text {
  margin-top: 30px;
  text-align: center;
}

</style>